import { fetchWrapper } from '@fukuri-admins/apis/fetchWrapper';
import { REQUEST_API_URL } from '@fukuri-admins/constants/common';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';

// fetchWrapperの第2引数の型を抽出（exportなしで型を取得）
type FetchOptions = Parameters<typeof fetchWrapper>[1];

export const partnerAdminFetch = async (
  endpoint: string,
  options: FetchOptions,
  onUnauthorized?: () => void
): Promise<Response> =>
  fetchWrapper(`${REQUEST_API_URL}/${getThreeLetterCode()}${endpoint}`, options, onUnauthorized);
